/**
 * The conflict mark: a filled triangle with an exclamation inside.
 *
 * Inherits `currentColor`, and everywhere it is used that colour is #ef3d23 —
 * the one red in the palette, reserved for "this will not work" rather than
 * merely "look here". Kept out of the generated icon set because it is drawn
 * here rather than exported from the brand's SVGs.
 */
export default function WarningGlyph({ size = 14 }: { size?: number | string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M12 2 1 21h22L12 2Zm0 6a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1Zm0 9.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z"
      />
    </svg>
  );
}
